<template>
    <b-card class="rounded-0 mb-n3">
        <b-form-group label-cols-sm="4" label-cols-lg="4" label="Handynummer" label-for="text-Handy">
            <b-input-group>
                <b-form-input id="text-Handy" :class="darkmode ? 'bg-dark text-light border-secondary' : ''"
                    type="tel" 
                    :state="validationPhone" 
                    v-model="value.handy"
                />
                <template v-slot:append>
                    <b-button v-b-popover.hover.topleft="'Trage deine Handynummer ein um sie per Knopfdruck mit anderen Nutzern zu teilen.'">
                        <img src="../assets/interface/hint.svg" 
                            class="mt-n1 mx-n1" 
                            style="filter:invert(1);height:1.2em" 
                        />
                    </b-button>
                </template>
            </b-input-group>
        </b-form-group>

        <b-form-group label-cols-sm="4" label-cols-lg="4" label="E-Mail-Adresse" label-for="text-Email">
            <b-input-group>
                <b-form-input id="text-Email" :class="darkmode ? 'bg-dark text-light border-secondary' : ''"
                    type="email" 
                    :state="validationEmail" 
                    v-model="value.email"
                />
                <template v-slot:append>
                    <b-button v-b-popover.hover.topleft="'Gib deine Email an um Benachrichtigungen zu neuen Anfragen und Nachrichten zu erhalten.'">
                        <img src="../assets/interface/hint.svg"
                            class="mt-n1 mx-n1" 
                            style="filter:invert(1);height:1.2em" 
                        />
                    </b-button>
                </template>
            </b-input-group>
        </b-form-group>
        <b-form-group v-if="value.email != null && value.email != ''" label-cols-sm="4" label-cols-lg="4" label="Benachrichtigungen" label-for="text-Benachrichtigungen"  >
            <b-form-select id="text-Benachrichtigungen" :class="darkmode ? 'bg-dark text-light border-secondary' : ''"
                v-model="value.benachrichtigungen"
                :options="benachrichtigungenOptions" 
            />
        </b-form-group>
    </b-card>
</template>

<script>
import { BCard, BInputGroup, BFormInput, BFormSelect, VBPopover } from "bootstrap-vue"
import { mapGetters } from 'vuex'
export default {
    name: "EinstellungenContactCard",
    components:{
        BCard,  
        BInputGroup, 
        BFormInput, 
        BFormSelect
    },
    directives:{
        'b-popover': VBPopover
    },
    props:{
        value: {}
    },
    computed: {
        ...mapGetters(['darkmode']),
        completed: (that) => that.validationEmail && that.validationPhone,
        validationEmail: (that) => that.value.email == null || that.value.email == '' ? true : that.regEmail.test(that.value.email),
        validationPhone: (that) => that.value.handy == null || that.value.handy == '' || that.regPhone.test(that.value.handy)
    },
    data(){
        return{
            benachrichtigungenOptions: [
                { value: 0, text: "Keine" },
                { value: 1, text: "Nur bei Anfragen" },
                { value: 2, text: "Bei Anfragen und Nachrichten" }
            ],
            regEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            regPhone: /^([+][0-9]{1,3}[ .-])?([(]{1}[0-9]{1,6}[)])?([0-9 .-/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
        }
    }
}
</script>